// src/data/planning/officialActivityCatalog.js

/**
 * REHBER360 - RESMÎ RPD FAALİYET HAVUZU
 *
 * Temel kural:
 * Bu dosyada yalnızca RPD Hizmetleri Sunum Sistemi /
 * e-Rehberlik'te karşılığı doğrulanmış faaliyetler bulunur.
 *
 * Plan robotu bu katalog dışında faaliyet üretemez.
 */

export const OFFICIAL_ACTIVITY_CATALOG_VERSION = "RPDH-2020-V1";

export const OFFICIAL_ACTIVITY_CATALOG = [

  // =========================================================
  // GRUP ÇALIŞMALARI
  // DESTEK HİZMETLER
  // PROGRAM YÖNETİMİ / ARAŞTIRMA / PROJE
  // =========================================================

  {
    id: "annual_rpd_program_preparation",

    officialLabel: "Okul/Kurum RPD Programının Hazırlanması",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE13"]
    },

    active: true
  },

  {
    id: "school_risk_map_creation",

    officialLabel: "Okul Risk Haritasının Oluşturulması",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE11"]
    },

    active: true
  },

  {
    id: "service_decimal_file_creation",

    // Excel'de ifade iki ardışık satıra bölünmüş durumda.
    officialLabel:
      "Rehberlik ve Psik.Danışma Servisi Desimali Oluşturulması",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE24", "AE25"]
    },

    active: true
  },

  {
    id: "rpd_needs_analysis",

    officialLabel: "RPD İhtiyaç Analizinin Yap.",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE29"]
    },

    active: true
  },

  {
    id: "rpd_commission_creation",

    officialLabel:
      "RPD Hizmetleri Yürütme Komisyonunun Oluşturulması",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE30"]
    },

    active: true
  },

  {
    id: "rpd_commission_meeting",

    officialLabel:
      "RPDH Yürütme Komisyonu Toplantısının Yapılması",

    workMode: "group",
    serviceDomain: "support",
    serviceType: "program_management",

    audience: ["school"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["AE32"]
    },

    active: true
  },

  // =========================================================
  // GRUP ÇALIŞMALARI
  // GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER
  // BİREYİ TANIMA
  // =========================================================

  {
    id: "student_information_form",

    officialLabel: "Öğrenci Bilgi Formu",

    workMode: "group",
    serviceDomain: "developmental_preventive",
    serviceType: "individual_recognition",

    audience: ["student"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["R15"]
    },

    active: true
  },

  {
    id: "class_risk_map",

    officialLabel: "Sınıf Risk Haritası",

    workMode: "group",
    serviceDomain: "developmental_preventive",
    serviceType: "individual_recognition",

    audience: ["student"],

    source: {
      system: "RPDH_SUNUM_SISTEMI",
      version: "2020",
      cells: ["R27"]
    },

    active: true
  },


  // =========================================================
  // LİSE ÖRNEK ÇERÇEVE PLANI - STANDART ÇALIŞMALAR
  // =========================================================

  {
    id: "school_environment_adaptation",

    officialLabel:
      "Okula ve Çevreye Uyum",

    workMode: "group",
    serviceDomain:
      "developmental_preventive",
    serviceType: "information",

    audience: ["student"],

    source: {
      system:
        "LISE_ORNEK_CERCEVE_PLANI",
      version: "2025-2026"
    },

    active: true
  },

  {
    id: "school_rules_information",

    officialLabel:
      "Okul kuralları",

    workMode: "group",
    serviceDomain:
      "developmental_preventive",
    serviceType: "information",

    audience: ["student"],

    source: {
      system:
        "LISE_ORNEK_CERCEVE_PLANI",
      version: "2025-2026"
    },

    active: true
  },

  {
    id: "bep_development_unit_meeting",

    officialLabel:
      "BEP Geliştirme Birimi Toplantıları",

    workMode: "group",
    serviceDomain: "support",
    serviceType:
      "cooperation_meetings",

    audience: ["school"],

    source: {
      system:
        "LISE_ORNEK_CERCEVE_PLANI",
      version: "2025-2026"
    },

    active: true
  },

  {
    id:
      "psychosocial_protection_crisis_meeting",

    officialLabel:
      "Okul Psikososyal Koruma, Önleme ve Krize Müdahale Toplantıları",

    workMode: "group",
    serviceDomain: "support",
    serviceType:
      "cooperation_meetings",

    audience: ["school"],

    source: {
      system:
        "LISE_ORNEK_CERCEVE_PLANI",
      version: "2025-2026"
    },

    active: true
  },

  {
    id: "school_risk_maps",

    officialLabel:
      "Okul Risk Haritaları",

    workMode: "group",
    serviceDomain:
      "developmental_preventive",
    serviceType:
      "individual_recognition",

    audience: ["student"],

    source: {
      system:
        "LISE_ORNEK_CERCEVE_PLANI",
      version: "2025-2026"
    },

    active: true
  },



    // =========================================================
// ÖĞRETMENE YÖNELİK MÜŞAVİRLİK
// =========================================================

{
  id: "teacher_individual_recognition_consultancy",

  officialLabel: "Bireyi Tanıma Teknikleri",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AB16"]
  },

  active: true
},


// =========================================================
// ŞİDDETİN ÖNLENMESİ
// =========================================================

{
  id: "violence_prevention_student",

  officialLabel: "Şiddeti Önleme",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T23"]
  },

  active: true
},

{
  id: "violence_prevention_parent",

  officialLabel: "Şiddetin Önlenmesi",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA43"]
  },

  active: true
},

{
  id: "violence_prevention_teacher",

  officialLabel: "Şiddetin Önlenmesi",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC43"]
  },

  active: true
},


// =========================================================
// KADINA YÖNELİK ŞİDDETİN ÖNLENMESİ
// =========================================================

{
  id: "violence_against_women_student",

  officialLabel: "Kadına Yönelik Şiddetin Önlenmesi",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["S33"]
  },

  active: true
},

{
  id: "violence_against_women_parent",

  officialLabel: "Kadına Yönelik Şiddetin Önlenmesi",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",

    // Kaynak Excel'de ifade iki hücreye bölünmüş.
    cells: ["Z48", "Z49"]
  },

  active: true
},

{
  id: "violence_against_women_teacher",

  officialLabel: "Kadına Yönelik Şiddetin Önlenmesi",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AB46"]
  },

  active: true
},


// =========================================================
// RİBA - REHBERLİK İHTİYAÇLARI BELİRLEME
// =========================================================

// OKUL ÖNCESİ

{
  id: "riba_preschool_teacher",

  officialLabel: "RİBA  (Okulöncesi-Öğretmen Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["teacher"],
  schoolLevels: ["preschool"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R19"]
  },

  active: true
},

{
  id: "riba_preschool_parent",

  officialLabel: "RİBA (Okulöncesi-Veli Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["parent"],
  schoolLevels: ["preschool"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R23"]
  },

  active: true
},


// İLKOKUL

{
  id: "riba_primary_student",

  officialLabel: "RİBA  (İlkokul-Öğrenci Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["student"],
  schoolLevels: ["primary"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R16"]
  },

  active: true
},

{
  id: "riba_primary_teacher",

  officialLabel: "RİBA (İlkokul-Öğretmen Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["teacher"],
  schoolLevels: ["primary"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R20"]
  },

  active: true
},

{
  id: "riba_primary_parent",

  officialLabel: "RİBA (İlkokul-Veli Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["parent"],
  schoolLevels: ["primary"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R24"]
  },

  active: true
},


// ORTAOKUL

{
  id: "riba_middle_student",

  officialLabel: "RİBA  (Ortaokul-Öğrenci Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["student"],
  schoolLevels: ["middle_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R17"]
  },

  active: true
},

{
  id: "riba_middle_teacher",

  officialLabel: "RİBA(Ortaokul-Öğretmen Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["teacher"],
  schoolLevels: ["middle_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R21"]
  },

  active: true
},

{
  id: "riba_middle_parent",

  officialLabel: "RİBA (Ortaokul-Veli Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["parent"],
  schoolLevels: ["middle_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R25"]
  },

  active: true
},


// LİSE / ORTAÖĞRETİM

{
  id: "riba_high_student",

  officialLabel: "RİBA  (Lise-Öğrenci Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["student"],
  schoolLevels: ["high_school", "vocational_high_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R18"]
  },

  active: true
},

{
  id: "riba_high_teacher",

  officialLabel: "RİBA (Lise-Öğretmen Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["teacher"],
  schoolLevels: ["high_school", "vocational_high_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R22"]
  },

  active: true
},

{
  id: "riba_high_parent",

  officialLabel: "RİBA (Lise-Veli Formu)",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "individual_recognition",

  audience: ["parent"],
  schoolLevels: ["high_school", "vocational_high_school"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["R26"]
  },

  active: true
},

  // =========================================================
// TBM / BAĞIMLILIKLA MÜCADELE
// ÖĞRENCİ FAALİYETLERİ
// =========================================================

{
  id: "tbm_student_healthy_life",

  officialLabel: "(TBM) Sağlıklı Yaşam",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Sağlıklı Yaşam"
  ],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T28"]
  },

  active: true
},

{
  id: "tbm_student_technology",

  officialLabel: "(TBM) Teknoloji Bağımlılığı",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Teknoloji Bağımlılığı"
  ],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T30"]
  },

  active: true
},

{
  id: "tbm_student_tobacco",

  officialLabel: "(TBM) Tütün Bağımlılığı",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Tütün Bağımlılığı"
  ],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T32"]
  },

  active: true
},

{
  id: "tbm_student_alcohol",

  officialLabel: "(TBM) Alkol Bağımlılığı",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Alkol Bağımlılığı"
  ],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T24"]
  },

  active: true
},

{
  id: "tbm_student_substance",

  officialLabel: "(TBM) Madde Bağımlılığı",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Madde Bağımlılığı"
  ],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T26"]
  },

  active: true
},

{
  id: "tbm_student_gambling",

  officialLabel: "(TBM) Kumar Bağımlılığı",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  officialPath: [
    "Ö - GELİŞİMSEL VE ÖNLEYİCİ HİZMETLER",
    "ÖÖV - Bilgi Verme Çalışmaları",
    "ÖÖVK - Sosyal-Duygusal Gelişim",
    "ÖÖVKg - (TBM) Kumar Bağımlılığı"
  ],

  source: {
    system: "E_REHBERLIK_GUIDE",
    version: "2025-2026",
    printedPage: 15
  },

  active: true
},

{
  id: "student_cyberbullying",

  officialLabel: "Siber Zorbalık",

  workMode: "group",
  serviceDomain: "developmental_preventive",
  serviceType: "information",

  audience: ["student"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["T20"]
  },

  active: true
},


// =========================================================
// TBM / BAĞIMLILIKLA MÜCADELE
// VELİ FAALİYETLERİ
// =========================================================

{
  id: "tbm_parent_healthy_life",

  officialLabel: "(TBM) Sağlıklı Yaşam",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA48"]
  },

  active: true
},

{
  id: "tbm_parent_technology",

  officialLabel: "(TBM) Teknoloji Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA50"]
  },

  active: true
},

{
  id: "tbm_parent_conscious_technology",

  officialLabel: "Bilinçli Teknoloji Kullanımı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["Z16"]
  },

  active: true
},

{
  id: "tbm_parent_tobacco",

  officialLabel: "(TBM) Tütün Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA52"]
  },

  active: true
},

{
  id: "tbm_parent_alcohol",

  officialLabel: "(TBM) Alkol Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA44"]
  },

  active: true
},

{
  id: "tbm_parent_substance",

  officialLabel: "(TBM) Madde Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AA46"]
  },

  active: true
},

{
  id: "tbm_parent_gambling",

  officialLabel: "(TBM) Kumar Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "parent",
  audience: ["parent"],

  source: {
    system: "E_REHBERLIK_GUIDE",
    version: "2025-2026",
    printedPage: 18
  },

  active: true
},


// =========================================================
// TBM / BAĞIMLILIKLA MÜCADELE
// ÖĞRETMEN FAALİYETLERİ
// =========================================================

{
  id: "tbm_teacher_healthy_life",

  officialLabel: "(TBM) Sağlıklı Yaşam",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC48"]
  },

  active: true
},

{
  id: "tbm_teacher_technology",

  officialLabel: "(TBM) Teknoloji Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC50"]
  },

  active: true
},

{
  id: "tbm_teacher_conscious_technology",

  officialLabel: "Bilinçli Teknoloji Kullanımı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AB14"]
  },

  active: true
},

{
  id: "tbm_teacher_tobacco",

  officialLabel: "(TBM) Tütün Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC52"]
  },

  active: true
},

{
  id: "tbm_teacher_alcohol",

  officialLabel: "(TBM) Alkol Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC44"]
  },

  active: true
},

{
  id: "tbm_teacher_substance",

  officialLabel: "(TBM) Madde Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "RPDH_SUNUM_SISTEMI",
    version: "2020",
    cells: ["AC46"]
  },

  active: true
},

{
  id: "tbm_teacher_gambling",

  officialLabel: "(TBM) Kumar Bağımlılığı",

  workMode: "group",
  serviceDomain: "support",
  serviceType: "consultancy",

  consultancyAudience: "teacher",
  audience: ["teacher"],

  source: {
    system: "E_REHBERLIK_GUIDE",
    version: "2025-2026",
    printedPage: 20
  },

  active: true
}

];


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getOfficialActivityById = (activityId) => {
  return (
    OFFICIAL_ACTIVITY_CATALOG.find(
      activity => activity.id === activityId && activity.active
    ) || null
  );
};


export const isOfficialActivity = (activityId) => {
  return OFFICIAL_ACTIVITY_CATALOG.some(
    activity => activity.id === activityId && activity.active
  );
};


export const getOfficialActivitiesByAudience = (audience) => {
  return OFFICIAL_ACTIVITY_CATALOG.filter(
    activity =>
      activity.active &&
      activity.audience.includes(audience)
  );
};